<template>
 <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex  xs12 sm8 md5 lg4>
             <img src="../../assets/images/unoapp.png" class="form-head-logo mb-2"/>
              <hr/>
              <template v-if="loaded">
                  <template v-if="activated">
                    <h2 class="font-weight-bold mt-4">Account Activated</h2>
                    <p>Your account has been successfully activated.</p>
                    <v-card-text class="nmt-20">
                      <div class="px-5">
                        <router-link :to="{ name: 'Login' }">
                            <v-btn  color="primary">Login</v-btn>
                        </router-link>
                      </div>
                    </v-card-text>
                 </template>
                 <template v-else>
                   <h2 class="font-weight-bold mt-4">This invitation is no longer valid.</h2>
                    <p>If you have already accepted this invitation, you can try logging in.</p>
                    <div class="px-5">
                        <router-link :to="{ name: 'Login' }">
                            <v-btn  color="primary">Login</v-btn>
                        </router-link>
                      </div>
                 </template>
              </template>
              <template v-else>
                <block-spinner></block-spinner>
              </template>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import { mapActions } from 'vuex';
import NormalApi from '@/components/Controllers/NormalApi'; // Just naming as readable
import Helper from '@/components/Controllers/Helpers';
import Env from '@/env';
import { setTimeout } from 'timers';

export default {
  name: 'ActivateAccount',
  // data: () => ({
  data() {
    return {
      loaded: false,
      activated: false,
      errorMessage: '',
    };
  },
  props: {
    source: String,
  },
  mounted() {
     if( this.$route.query.token ){
       this.verifyAccountToken(this.$route.query.token )
     } else {
      this.$router.push({ name: 'Login' });
     }
  },

  methods: {
    verifyAccountToken(token) {
      const self = this;
      const url = `${Env.url}/api/v1/users/invite/${token}`;
      NormalApi.getApi(url)
      .then(res => {
        this.loaded = true;
        this.activated = true;
         
        if(res.data.hasOwnProperty('payload') && res.data.payload.reset_token){
          this.snackbar({
            text: 'Redirecting to reset account password.',
            timeout: 4000,
            open: true,
          });
          setTimeout(()=>{
            self.$router.push({ name: 'ResetPassword', query: { token: res.data.payload.reset_token}})
          }, 2000)
        }
        
      })
      .catch( err => {

        this.loaded = true;
        this.activated = false;
        this.snackbar({
          text: err.response ? err.response.data.msg : 'Please try again later',
          timeout: 4000,
          open: true,
        });
      })
    },
    ...mapActions({
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>

